<template>
  <div>
    <!-- 1.2 Head -->
    <!-- <Head></Head> -->
    <Logo></Logo>
    <!-- 2.  Swiper -->
    <Swipe :swipe="this.swipe"></Swipe>
    <!-- 3.  Search -->
    <!-- <div style="width: 750px; height: 18px; background-color: #f5f5f5"></div> -->
    <router-link to="/searchpage">
      <Search></Search>
    </router-link>
    <div
      style="width: 46.875rem; height: 1.125rem; background-color: #f5f5f5"
    ></div>
    <!-- 4.  Link -->
    <Link></Link>
    <div
      style="
        width: 46.875rem;
        height: 1rem;
        background-color: #f5f5f5;
        margin-top: 8.125rem;
      "
    ></div>
    <!-- 5.  Applications -->
    <Applications
      :categoryList="this.categoryList"
      :NewsList="this.NewsList"
      :IndList="this.IndList"
    ></Applications>
    <div
      style="background-color: #f5f5f5; height: 1rem; margin-top: 6.25rem"
    ></div>
    <!-- 6.  Messages -->
    <Messages></Messages>
    <div
      style="background-color: #f5f5f5; height: 3.5rem; margin-top: 6.25rem"
    ></div>
    <!-- 7.  Navbar -->
    <Navbar :message="this.message"></Navbar>
    <!-- 8.  Tabbar -->
    <div style="height:5.125rem;"><Tabbar></Tabbar></div>
  </div>
</template>

<script>
import Applications from './Index_components/Applications.vue'
import Link from './Index_components/Link.vue'
import Messages from './Index_components/Messages.vue'
import Navbar from './Index_components/Navbar.vue'
import Search from './Index_components/Search.vue'
import Swipe from './Index_components/Swipe.vue'
import Tabbar from './Index_components/Tabbar.vue'
import Head from './Index_components/Head.vue'
import Logo from "./Index_components/logo.vue"
import api from '@/utils/api'

export default {
  name: 'Index',
  components: {
    Applications,
    Head,
    Link,
    Messages,
    Navbar,
    Search,
    Swipe,
    Tabbar,
    Logo,
  },
  data () {
    return {
      swipe: [{
        'image': 'http://bjtstd.com.cn/media/images/carousel/1632735426_Group_953.png'
      }],
      message: {},
      NewsList: [],
      IndList: [],
      categoryList: [],
    }
  },
  created () {
    this.local()
  },
  methods: {
    // localstorage存储
    local () {
      var storage = window.localStorage
      if (!storage) {
        console.log('不支持localstorage')
        this.getIndex()
        return false
      } else {
        if (storage.getItem('res')) {
          var res = JSON.parse(storage.getItem('res'))
          console.log('我是本地存储', res)
          if (res.res1.code === 200) {
            this.swipe = res.res1.data
            console.log('我是本地轮播图', this.swipe)
          }

          if (res.res5.code === 200) {
            this.categoryList = res.res5.data
            console.log('我是本地首页产品', this.categoryList)
          }

          if (res.res3.code === 200) {
            this.NewsList = res.res3.data.results
            console.log('我是本地首页新闻', this.NewsList)
          }
          if (res.res4.code === 200) {
            this.IndList = res.res4.data.results
            console.log('我是本地首页行业资讯', this.IndList)
          }
          if (res.res2.code === 200) {
            this.message = res.res2.data[0]
            console.log('我是本地基础信息', res.res2.data[0])
          }
          // 时间多余500s则重新请求
          if (new Date().getTime() - res.time > 6500000) {
            console.log(new Date().getTime)
            console.log(res.currTime)
            storage.removeItem('res')
          }
        } else {
          console.log('本地化未存储')
          this.getIndex()
        }
      }
    },
    async getIndex () {
      const { data: res1 } = await api.getSwipe()
      const { data: res5 } = await api.getCategory()
      const { data: res3 } = await api.getNewsIndex()
      const { data: res4 } = await api.getIndIndex()
      const { data: res2 } = await api.getBase()
      var storage = window.localStorage
      var currTime = new Date().getTime()
      storage.setItem('res', JSON.stringify({
        res1: res1,
        res2: res2,
        res3: res3,
        res4: res4,
        res5: res5,
        time: currTime
      }))
      if (res1.code === 200) {
        this.swipe = res1.data
        console.log('我是轮播图', this.swipe)
      }

      if (res5.code === 200) {
        this.categoryList = res5.data
        console.log('我是首页产品', this.categoryList)
      }

      if (res3.code === 200) {
        this.NewsList = res3.data.results
        console.log('我是首页新闻', this.NewsList)
      }
      if (res4.code === 200) {
        this.IndList = res4.data.results
        console.log('我是首页行业资讯', this.IndList)
      }
      if (res2.code === 200) {
        this.message = res2.data[0]
        console.log('我是基础信息', res2.data[0])
      }
    }
  },
}
</script>
<style scoped>

</style>